app.component('addressee', {
    bindings: {
        add: '=',
        isChild: '=',
        returnUrl: '='
    },
    templateUrl:  _pb + 'employee/documents/document-addresses-component.html',
    controller: ['$scope', '$state', '$uibModal', function($scope, $state, $uibModal) {

        $scope.formatWithTime = "dd-MM-yyyy hh:mm:ss";
        $scope.format = "dd-MM-yyyy";

        $scope.generateStateClass = function (add) {
            if (new Date(add.deadline) < new Date()) {
                return 'doc-returned';
            }
        };

        $scope.generateClass = function (status) {
            if (!status || status === 'unread') return 'doc-unread';
            if (status === 'done') return 'doc-done';
            if (status === 'read') return 'doc-read';
            if (status === 'returned') return 'doc-returned';
        };

        $scope.generateTooltip = function (status) {
            if (!status || status === 'unread') return 'წაუკითხავი';
            if (status === 'done') return 'შესრულებული';
            if (status === 'read') return 'წაკითხული';
            if (status === 'returned') return 'მობრუნებული';
        };

        $scope.showComment = function (header, text, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            comment: {value: text},
                            header: header,
                            action: 'view'
                        };
                    }
                }
            })
        };

        $scope.openDocument = function (data) {
            var docId = data.add.outGoingStudentDocument._id
            $state.go('employee.documents.view', { actionType: 'sent', documentId: docId, returnUrl: data.returnUrl})
        }

    }]
});
